export default __webpack_public_path__ + "static/media/cx_cover_c60.784782a4.jpg";